// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ClockCircleTwoToneSvg from "@fishx/icons-svg/es/asn/ClockCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var ClockCircleTwoTone = function ClockCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ClockCircleTwoToneSvg
  }));
};

ClockCircleTwoTone.displayName = 'ClockCircleTwoTone';
export default React.forwardRef(ClockCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ClockCircleTwoTone.js
// module id = 2232
// module chunks = 0